import { TSearchAvailabilityState } from './domain';

export const DEFAULT_SEARCH_AVAILABILITY_STATE: TSearchAvailabilityState = {
    selectedDate: undefined,
    activities: '',
    partnerSlug: '',
    isMonthLoading: false,
    isSchedulesLoading: false,
    schedules: {},
    months: {},
};
